export default __webpack_public_path__ + "static/fWRKHHso-9fe4bd1f5e8fa9f9a83dbc142937a1b2.svg";